export default __webpack_public_path__ + "img/sowl-desktop-logo.fad282a.svg";